import React from "react"

const PoliciesContext = React.createContext({})

const { Provider, Consumer } = PoliciesContext

export { Provider, Consumer, PoliciesContext }
